import React from "react";
import "./CharityList.scss";
import $ from "jquery";
import {FcEditImage, FcFullTrash} from 'react-icons/fc';
import {FaAngleRight, FaEye, FaPencilAlt} from "react-icons/fa";
import { Link } from 'react-router-dom';
import MyContext from "../../MyContext";
import { AddButtonTheme1 } from "../../../res/styler/ButtonThemes/ButtonThemes";
import ReactPaginate from 'react-paginate';

class CharityList extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      charities : [],
      search_input : "",
      offset_value : 0,
      current_page : 0,
      per_page : 10,
      page_count : 0,
      page_no_input : 1
    }
    this.charity_list_page_Ref = React.createRef();
    this.form_change = this.form_change.bind(this);
    this.handle_page_click = this.handle_page_click.bind(this);
    this.page_no_change = this.page_no_change.bind(this);
    this.page_no_form_submit = this.page_no_form_submit.bind(this);
    this.getNotices = this.getNotices.bind(this);
    this.notices_XHR = {abort : () => {}}
  }

  componentDidMount(){
    if(this.props.history.location.state && typeof this.props.history.location.state == "object" && this.props.history.location.state.hasOwnProperty('offset_value')){
      this.setState({
        offset_value : this.props.history.location.state.offset_value,
        search_input : this.props.history.location.state.search_input,
        current_page : this.props.history.location.state.current_page,
        page_no_input : this.props.history.location.state.page_no_input
      },() => {
        window.scrollTo({
          top : this.charity_list_page_Ref.current.offsetTop - 80,
          behavior : "smooth"
        });
        this.getNotices();
      });
    }else{ 
      this.getNotices();
    }
  }

  form_change(e){
    this.state.offset_value = 0;
    this.state.current_page = 0;
    this.setState({
      [e.target.name] : e.target.value,
      page_no_input : 1
    },() => {
      this.getNotices();
    });
  }

  page_no_change(e){
    this.setState({
      page_no_input : e.target.value
    }); 
  }

  page_no_form_submit(e){
    window.scrollTo({
      top : this.charity_list_page_Ref.current.offsetTop - 80,
      behavior : "smooth"
    });
    e.preventDefault();
    this.setState({
      offset_value : (this.state.page_no_input -1) * this.state.per_page,
      current_page : this.state.page_no_input -1,
    },() => {
      this.getNotices();
    });
  }

  handle_page_click(e){
    this.charity_list_page_Ref.current.style.opacity = 0;
    window.scrollTo({
      top : this.charity_list_page_Ref.current.offsetTop - 80,
      behavior : "smooth"
    });
    this.setState({
      offset_value : e.selected * this.state.per_page,
      current_page : e.selected,
      page_no_input : e.selected +1
    },() => {
      this.getNotices()
    });
  }

  getNotices(){
    var obj_this = this;
    this.context.loading(1);
    this.notices_XHR.abort();
    this.notices_XHR = $.ajax({
      url : process.env.REACT_APP_API + "/api/allCharities",
      data :this.context.bind_session({
        search_phrase : this.state.search_input,
        offset_value : this.state.offset_value
      }),
      type : "POST"
    }).done(function(return_data){
      // console.log(return_data);
      if(return_data.status == "success"){
        obj_this.setState({
          charities : return_data.charities,
          page_count :  Math.ceil(return_data.page_count / obj_this.state.per_page)
        }, () => {
          obj_this.context.loading(0);
          obj_this.charity_list_page_Ref.current.style.visibility = "visible";
          obj_this.charity_list_page_Ref.current.style.opacity = 1;
        });
        obj_this.context.setHistoryState({
          charities : return_data.charities,
          page_count :  Math.ceil(return_data.page_count / obj_this.state.per_page),
          offset_value : obj_this.state.offset_value,
          current_page : obj_this.state.current_page,
          search_input : obj_this.state.search_input,
          page_no_input : obj_this.state.page_no_input,
        },obj_this.props.history);
      }else{
        obj_this.context.loading(0);
        $.alert("Something Went Wrong. Please Try Again.");
      }
    }).fail(function (jqXHR, textStatus) {
      if (textStatus != "abort") {
        alert("Network error");
      } 
    });
  }

  render(){
    return(
      <div className="charity_list_page_container page_container" ref={this.charity_list_page_Ref}>
        <div className="page_header">
          <div className="page_title">Charities</div>
          <div className="search_container">
            <input
              className="search_input"
              name="search_input"
              type="text"
              value={this.state.search_input}
              onChange={this.form_change}
              placeholder="Search..."
            />
            <i className="fas fa-search search_icon"></i>
          </div>
          <Link className="new_death_notice_button" to="/Dashboard/NewCharity">
            <AddButtonTheme1 label="Add new charity"/>
          </Link>
        </div>
        <div className="charity_type_select_container">
        </div>
        <div className="custom_table_theme1">
          <div className="table_row header">
            <div className="table_cell sl_no">Sl No.</div>
            <div className="table_cell fullname">Name</div>
            <div className="table_cell notice_type">Address</div>
            <div className="table_cell datetime">City</div>
            <div className="table_cell">State</div>
            <div className="table_cell">Published Date</div>
            <div className="table_cell">Action</div>
          </div>
          {this.state.charities && this.state.charities.map((item,idx) => (
            <div className="table_row body"
              key={idx} 
            >
              <div className="table_cell sl_no">{this.state.offset_value+idx+1}</div>
              <div className="table_cell">{item.name}</div>
              <div className="table_cell notice_type">{item.address}</div>
              <div className="table_cell">{item.city}</div>
              <div className="table_cell">{item.flag} {item.state}</div>
              <div className="table_cell">{new Date(item.created_at).toLocaleDateString('en-GB')}</div>
              {/* <div className="table_cell">
                <div className="action">
                  <div className="tooltip approve">
                    <span className="tooltipText approve">Preview</span>
                    <FaEye className="approve_button" onClick={() =>  this.props.history.push("/Dashboard/ViewCharity/"+item.id)}/>
                  </div>
                  <div className="tooltip delete">
                    <span className="tooltipText edit">Edit</span>
                    <FcEditImage className="delete_button" onClick={() => this.props.history.push("/Dashboard/EditCharity/"+item.id)}/>
                  </div>
                </div>
              </div> */}
              <div className="table_cell" style={{minWidth:"115px"}}>
                <div className="action">
                  <Link className="tooltip approve" to={{
                    pathname: "/Preview/Charity/" + item.id,
                    url : "/Dashboard/Charities/All",
                    previousState : {
                      offset_value : this.state.offset_value,
                      current_page : this.state.current_page,
                      search_input : this.state.search_input,
                      page_no_input : this.state.page_no_input,
                    }
                    }}>
                    <span className="tooltipText approve">View</span>
                    <FaEye
                      className="approve_button"/>
                  </Link>
                  <Link className="tooltip edit" to={{
                    pathname: "/Dashboard/EditCharity/"+item.id,
                    url : "/Dashboard/Charities/All",
                    previousState : {
                      offset_value : this.state.offset_value,
                      current_page : this.state.current_page,
                      search_input : this.state.search_input,
                      page_no_input : this.state.page_no_input,
                    }
                    }} style={{visibility: (item.status == "PUBLISHED" || item.status == "PENDING") ?"visible":"hidden"}}>
                    <span className="tooltipText edit">Edit</span>
                    <FaPencilAlt className="edit_button"/>
                  </Link>
                  <Link className="tooltip delete" to={{
                    pathname: "/Preview/Charity/"+item.id,
                    url : "/Dashboard/Charities/All",
                    action : "delete",
                    previousState : {
                      offset_value : this.state.offset_value,
                      current_page : this.state.current_page,
                      search_input : this.state.search_input,
                      page_no_input : this.state.page_no_input,
                    }
                    }} style={{visibility:(item.status == "PUBLISHED") ?"visible":"hidden"}}>
                    <span className="tooltipText delete">Delete</span>
                    <FcFullTrash className="delete_button"/>
                  </Link>
                </div>
            </div>
          </div>
          ))}
          <div className="table_row no_results" style={{display:this.state.charities.length?"none":"block"}}>No results.</div>
        </div>
        <div className="pagination_container" style={{display:this.state.charities.length && this.state.page_count > 1?"block":"none"}}>
          <ReactPaginate
            previousLabel={"PREV"}
            nextLabel={"NEXT"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={this.state.page_count}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={this.handle_page_click}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={this.state.current_page}
          />
          <form className="page_no_search_form" onSubmit={this.page_no_form_submit}>
            <span className="page_count">Go to page</span>
            <input className="page_no_input"
              type="number"
              name="page_count"
              value={this.state.page_no_input}
              onChange={this.page_no_change}
              min={1}
              max={this.state.page_count}
            />
            <button type="submit" className="page_no_search_button">
              <span>Go</span>
              <FaAngleRight/>
            </button>
          </form>
        </div>
      </div>
    )
  }
}

export default CharityList;
CharityList.contextType = MyContext;